import { useEffect, useMemo } from 'react';
import { ownedBy } from '../content/outbox';
import { pruneSent, withQueued } from '../content/queued-sessions';
import { replaceOutbox, useOutbox } from './outbox-store';
import { useMe } from './use-me';
import { useSessions } from './use-sessions';

/**
 * The sessions every count and "what is next" reads: Core's, plus the signed-in person's
 * attempts not in Core's history yet — queued, or recorded and waiting to show up there — which
 * count as done at once. The sessions cache itself only ever holds what Core returned; saving an
 * exercise reads `useSessions`, so nothing is written into a local attempt's row.
 */
export function useLocalSessions() {
  const sessions = useSessions();
  const outbox = useOutbox();
  const person = useMe().data?.uuid;
  const data = useMemo(
    () => (sessions.data ? withQueued(sessions.data, ownedBy(outbox, person)) : undefined),
    [sessions.data, outbox, person],
  );
  useEffect(() => {
    if (!sessions.data) return;
    const kept = pruneSent(outbox, person, sessions.data, Date.now());
    if (kept) replaceOutbox(kept);
  }, [sessions.data, outbox, person]);
  return { ...sessions, data };
}
